import React from 'react';
import CredentialCard from './CredentialCard';

interface CredentialsTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  credentials: any[];
  onCredentialClick: (credential: any) => void;
  showTabsOnly?: boolean;
}

const CredentialsTabs: React.FC<CredentialsTabsProps> = ({
  activeTab,
  onTabChange,
  credentials,
  onCredentialClick,
  showTabsOnly = false
}) => {
  const tabs = [
    { id: 'all', label: 'All Credentials' },
    { id: 'badges', label: 'Digital Badges' },
    { id: 'passports', label: 'Digital Passports' }
  ];

  const filteredCredentials = credentials.filter(credential => {
    if (activeTab === 'all') return true;
    if (activeTab === 'badges') return credential.type === 'badges';
    if (activeTab === 'passports') return credential.type === 'passports';
    return true;
  });

  return (
    <div className="">
      {/* Tabs */}
      <div className="border rounded-2xl border-gray-200 bg-gray-900/30 p-1">
        <nav className="flex flex-row items-stretch justify-stretch">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full text-sm font-normal border rounded-xl transition-colors text-white py-0.5 ${
                activeTab === tab.id
                  ? 'border-blue-600 bg-blue-600'
                  : 'border-transparent bg-transparent text-gray-500 hover:text-white hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {!showTabsOnly && (
        <>
          <div className="py-6">
            <p className="text-white mb-6">
              View all your credentials including individual Microskill badges and complete Skillstore Digital Passports
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {filteredCredentials.map(credential => {
                const credentialId = credential.uuid || credential.unique_code || credential.id;
                return (
                  <CredentialCard
                    key={credentialId}
                    credential={credential}
                    onClick={() => onCredentialClick(credential)}
                  />
                )}
              )}
            </div>

            {filteredCredentials.length === 0 && (
              <div className="text-center py-12">
                <p className="text-gray-500">No credentials found for this category.</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CredentialsTabs;